import React, { useContext } from 'react'
import { Col, Row, Card, Table } from '@themesberg/react-bootstrap'
import { TableRow } from '../component/TableRow'
import Pagination from '../../../../../components/Pagination'
import { Context } from '../RefundHistory'

const _Table = () => {

  const { state, dispatch } = useContext(Context);

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Table responsive className="align-items-center table-bordered table-hover">
          <thead className='text-center'>
            <tr>
              <th scope="col" style={{ width: '25%' }}>Người chơi</th>
              <th scope="col">Mã đơn</th>
              <th scope="col">Trò chơi</th>
              <th scope="col" style={{ width: '20%' }}>Số tiền hoàn</th>
              <th scope="col">Ngày hoàn</th>
            </tr>
          </thead>
          <tbody>
            {(!state.data.list || state.data.list.length === 0) ? (
              <tr>
                <td colSpan="5" className="text-center py-4 text-muted">Không có giao dịch hoàn tiền</td>
              </tr>
            ) : state.data.list.map((pv, index) => <TableRow rIndex={index} key={`table-keys-lottmekong-refund-${pv.id}`} {...pv} />)}
          </tbody>
        </Table>
        <Card.Footer className='flex-row'>
          <Row className="align-items-center">
            <Col>
              <Pagination
                totalPage={state.data.totalPage || 0}
                currentPage={state.filter.page || 0}
                onPageChange={(i) => {
                  dispatch({
                    type: 'UPDATE_PAGE',
                    payload: i
                  })
                }}
              />
            </Col>
          </Row>
        </Card.Footer>
      </Card>
    </>
  );
};

export default React.memo(_Table)
